<div class="wrapper" (click)="onClick($event)">
  <button
    [id]="id + '-button'"
    [ngClass]="{
      regular: type === buttonType.Regular,
      flat: type === buttonType.Flat,
      link: type === buttonType.Link,
      attractive: attractive !== buttonAttractive.None,
      heavy: attractive === buttonAttractive.Heavy,
      alternative: skin === themeSkin.Alternative,
      start: alignement === buttonAlignement.Start,
      end: alignement === buttonAlignement.End,
      hasIcon: icon !== buttonIcon.None
    }"
    [disabled]="disabled"
    >
    @if (icon !== buttonIcon.None) {
      <div
        [id]="id + '-button'"
        class="icon"
      [ngClass]="{
        noContent: !content.innerHTML.trim(),
        start: alignement === buttonAlignement.Start,
        end: alignement === buttonAlignement.End,
        add: icon === buttonIcon.Add,
        addComment: icon === buttonIcon.AddComment,
        edit: icon === buttonIcon.Edit,
        view: icon === buttonIcon.View,
        hide: icon === buttonIcon.Hide,
        save: icon === buttonIcon.Save,
        delete: icon === buttonIcon.Delete,
        upload: icon === buttonIcon.Upload,
        download: icon === buttonIcon.Download,
        library: icon === buttonIcon.Library,
        filterInActive: icon === buttonIcon.FilterInActive,
        filterActive: icon === buttonIcon.FilterActive,
        search: icon === buttonIcon.Search,
        bookmarkInActive: icon === buttonIcon.BookmarkInActive,
        bookmarkActive: icon === buttonIcon.BookmarkActive,
        debug: icon === buttonIcon.Debug,
        message: icon === buttonIcon.Message,
        previous: icon === buttonIcon.Previous,
        next: icon === buttonIcon.Next,
        fullscreenEnter: icon === buttonIcon.FullScreenEnter,
        fullscreenExit: icon === buttonIcon.FullScreenExit,
        history: icon === buttonIcon.History,

        more: icon === buttonIcon.More,
        collapse: icon === buttonIcon.Collapse,
        expand: icon === buttonIcon.Expand,
        expandAll: icon === buttonIcon.ExpandAll,
        collapseAll: icon === buttonIcon.CollapseAll,
        link: icon === buttonIcon.Link,
        duplicate: icon === buttonIcon.Duplicate,
        externalLink: icon === buttonIcon.ExternalLink,
        setAsDefault: icon === buttonIcon.SetAsDefault,
        reject: icon === buttonIcon.Reject,
        indent: icon === buttonIcon.Indent,
        outdent: icon === buttonIcon.Outdent,
        orderedList: icon === buttonIcon.OrderedList,
        quiz: icon === buttonIcon.Quiz,
        unorderedList: icon === buttonIcon.UnorderedList,
        undo: icon === buttonIcon.Undo,
        redo: icon === buttonIcon.Redo,
        switch: icon === buttonIcon.Switch,
        zoomReset: icon === buttonIcon.ZoomReset,
        reset: icon === buttonIcon.Reset,
        modules: icon === buttonIcon.Modules,
        modulesAdd: icon === buttonIcon.ModulesAdd,
        scan: icon === buttonIcon.Scan,
        share: icon === buttonIcon.Share
      }"
      ></div>
    }
    <div #content>
      <ng-content></ng-content>
    </div>
  </button>
</div>
